import React from "react";

const NonConformityLabel = (props) => {
    if(props.value === "NC Pending") {
        return(
            <span title="NC Pending" className="me-1">
                <div className="avatar-xxs img-thumbnail rounded-circle" style={{display:"inline-block", padding:"0"}}>
                    <div className="avatar-title text-uppercase border rounded-circle bg-warning">P</div>
                </div>
            </span>
        );
    }
    else if(props.value === "NC Accepted") {
        return(
            <span title="NC Accepted" className="me-1">
                <div className="avatar-xxs img-thumbnail rounded-circle" style={{display:"inline-block", padding:"0"}}>
                    <div className="avatar-title text-uppercase border rounded-circle bg-success">A</div>
                </div>
            </span>
        );
    }
    else if(props.value === "NC Rejected") {
        return(
            <span title="NC Rejected" className="me-1">
                <div className="avatar-xxs img-thumbnail rounded-circle" style={{display:"inline-block", padding:"0"}}>
                    <div className="avatar-title text-uppercase border rounded-circle bg-danger">R</div>
                </div>
            </span>
        );
    }

    return "";
};

export default NonConformityLabel;